import styled from 'styled-components'
import theme from 'styles/theme'
import { Eyebrow, Title26 } from 'components/Typography'

const gridGap = 20
const imageRatio = (240 / 380) * 100

export const Wrapper = styled.div`
  margin: auto;
  max-width: ${theme.breakpoints.lg};
  overflow: hidden;
  padding: 0;

  ${theme.mediaQueries.large} {
    padding: 100px 0;
  }
`

export const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -${gridGap}px;
  padding: 0 0 0 ${gridGap}px;
  justify-items: space-between;
`

export const Card = styled.div`
  background-color: ${theme.colors.coaldark};
  background-clip: content-box;
  border: 0px solid transparent;
  flex: 1 0 100%;
  margin-bottom: ${gridGap}px;
  position: relative;
  text-align: center;
  width: 100%;

  ${theme.mediaQueries.small} {
    flex: 0 0 50%;
    border-right: ${gridGap}px;
    padding-right: ${gridGap}px;
    max-width: 50%;
  }

  ${theme.mediaQueries.medium} {
    flex: 0 0 calc(100% / 3);
    max-width: 33.3%;
  }
`

export const CardLink = styled.a`
  display: block;
  position: relative;
  width: 100%;
  height: 100%;
`

export const CardBg = styled.div`
  background-position: center;
  background-size: cover;
  height: 240px;
  opacity: 0.65;
  width: 100%;

  ${theme.mediaQueries.small} {
    height: auto;
    padding-bottom: ${imageRatio}%;
  }
`

export const CardBody = styled.div`
  color: ${theme.colors.white};
  position: absolute;
  width: 100%;
  height: 50%;
  top: 50%;
  left: 0;
`

export const CardLocation = styled(Eyebrow)`
  display: block;
`

export const CardName = styled(Title26)`
  color: ${theme.colors.sagefeather};
`
